import React from "react";
import { string, array, number, oneOfType } from "prop-types";
import { Box, Typography } from "@mui/material";
import { formateDate } from "../../../utils/date";

// TODO: use i18n?

const ReportSnapshotHeader = (props) => {
  const { condition, date } = props;

  const dateDisplay = date ? ` ${formateDate(date)}` : null;

  return (
    <Box
      sx={(theme) => ({
        display: "flex",
        justifyContent: "space-between",
        paddingLeft: theme.spacing(3),
        paddingRight: theme.spacing(3),
        paddingTop: theme.spacing(2),
        paddingBottom: theme.spacing(2),
        backgroundColor: "white",
        borderBottom: "1px solid #1A80D31A",
        alignItems: "baseline",
        flexWrap: "wrap",
        gap: theme.spacing(1),
      })}
    >
      <Typography
        sx={(theme) => ({
          fontSize: 28,
          lineHeight: "32px",
          fontWeight: 600,
          color: "black",
          paddingRight: theme.spacing(2),
        })}
      >
        {condition}
      </Typography>
      {dateDisplay && (
        <Typography variant="body1" sx={{ "& span": { fontWeight: 700 } }}>
          Date of review:
          <Typography component="span">{dateDisplay}</Typography>
        </Typography>
      )}
    </Box>
  );
};

ReportSnapshotHeader.propTypes = {
  drugs: array,
  condition: string.isRequired,
  date: oneOfType([string, number]),
  year: oneOfType([string, number]),
};

export default ReportSnapshotHeader;
